import { DocumentTypes } from '../enums/home.enum';

export interface DashboardDetails {
  ESRS?: DocumentItem;
  SASB?: DocumentItem;
  totalDocuments?: string;
  extractionTimeCount?: any;
}

export interface DocumentArray extends Array<DocumentItem> {}

export interface DocumentItem {
  documentTypeId?: number;
  documentType?: DocumentTypes;
  count?: number;
  countFormatted?: string;
}

export interface ExtractionTime {
  maxExtractionTime: any;
}

export interface Histories {
  uId: string;
  description: string;
  eventDate: string;
  clientIdentifier: string;
}

export interface Engagement {
  uId: string;
  name: string;
  startDate: string;
  revenuePerYear: string;
  clientIdentifier: string;
  metrics: IMetrics[];
  gds: number | null;
  onshore: number | null;
}
export interface Competency {
  [key: string]: Engagement[];
}
export interface IMetrics {
  uId: string;
  name: string;
  count: number;
  status: number;
  statusName: string;
  engagementIdentifier: string;
}
export interface IRiskManagement {
  baseImg: string;
  engagementName: string;
  clientIdentifier: string;
  uId: string;
  risk: string;
  severity: string;
  severityText: string;
  owner: string;
  ownerEmail: string;
  mitigationPlan: string;
  engagementIdentifier: string;
}
export interface ITestimonials {
  baseImg: string;
  uId: string;
  ownerName: string;
  ownerEmail: string;
  sharedDetails: string;
  clientIdentifier: string;
}
export interface ICaseStudies{
  url: string;
  id: string;
  subTitle: string;
  title: string;
  description: string;
}
export interface InnovationAndProductivity {
  clientIdentifier: string;
  engagementIdentifier: string;
  engagementName: string;
  longDescription: string;
  name: string;
  shortDescription: string;
  status: string;
  uId: string;
  imageUrl: string;
}
export interface InitiativeTab {
  activeIcon: string;
  inActiveIcon: string;
  name: string;
  count: number;
  active: boolean;
}
export interface IBillingDetail {
  uId: string;
  billableHours: string;
  nonBillableHours: string;
  clientIdentifier: string;
}
export interface BillableHoursChartData {
  id: string | Number;
  color: string;
  value?: string | Number;
}
export interface ClientDetails {
  custSatisfactionLevelCurrent: string;
  custSatisfactionLevelLast: string;
  slaComplianceCurrent: number;
  slaComplianceLast: number;
  clientIdentifier: string;
  clientName: string;
  clientDescription: string;
  createdAt: string;
  updatedAt: string;
}
export interface ChatBotData {
  welcomeText: string;
  choices: Array<ChatBotObject>;
}
export interface VisibleChatBotData {
  Level: Array<ChatBotObject>;
}
export interface ChatBotObject {
id: string;
title:string;
responses?:Array<ChatBotObject>;
selected?: Boolean;
selectedDate?:string;
selectedTime?:string;
initialOptions?:Boolean;
user?: Boolean;
contentURL?: string;
}

export interface ComponentType<T = any> {
  new (...args: any[]): T;
}
